import React from "react";

export const HeadlineContext = React.createContext(1);
